import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  role?: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-220">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-221">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-222">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-neutral-900 border border-amber-900/40 rounded-lg p-4" data-id="element-223">
              <div className="flex gap-1 mb-2" data-id="element-224">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-225" />)}
              </div>
              <p className="text-neutral-300 mb-2 leading-relaxed text-sm" data-id="element-226">
                "{testimonial.text}"
              </p>
              <div className="text-sm" data-id="element-227">
                <p className="text-amber-50 font-semibold" data-id="element-228">
                  {testimonial.name}
                </p>
                <p className="text-neutral-400 text-xs" data-id="element-229">
                  {testimonial.location}
                  {testimonial.role && ` · ${testimonial.role}`}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}